<template>
  <div>
    <v-tabs
      v-model="tastoMenu"
      center-active
      background-color="light-green lighten-5"
      class="mb-0 mt-0"
    >
      <v-tab
        overlap
        v-for="m in tastiMenu"
        :key="m.codice"
        @click="cambioMenu(m.codice)"
        class="mr-5"
      >
        <v-badge
          :value="mostraBadge(m.codice)"
          :color="coloreBadgeMenu(m.codice)"
          :content="numeroMenu(m.codice)"
          >{{ m.descrizione }}</v-badge
        >
      </v-tab>
    </v-tabs>
    <v-container fluid dense>
      <v-row dense>
        <v-col class="text-h5" cols="3" @click.stop="drawer = !drawer"
          >Menù selezionati: <span>{{ totaleMenu }}</span></v-col
        >
        <v-col
          class="text-h5"
          cols="3"
          :class="{ 'red--text font-weight-medium': totaleSfusi > 0 }"
          back
          >Pezzi sfusi: <span>{{ totaleSfusi }}</span></v-col
        >
        <v-col class="text-h5" cols="3"
          >Pezzi totali: <span>{{ totalePezzi }}</span></v-col
        >
        <v-spacer />
        <v-col
          v-if="posizioneMenuScelti === 'drawer'"
          class="text-h5 d-flex justify-end mr-3"
          cols="1"
          ><v-btn @click.stop="drawer = !drawer">Carrello</v-btn></v-col
        >
      </v-row>
      <v-row dense>
        <v-col v-if="posizioneMenuScelti === 'affiancato'">
          <v-card
            :width="`${100 / (gruppi.length + 1)}vw`"
            color="light-green lighten-5"
          >
            <v-card-title style="padding-top: 5px; padding-bottom:5px;"
              >Menù scelti</v-card-title
            >
            <!-- <v-list transition="slide-x-transition" dense> -->
            <v-virtual-scroll
              :items="menuCreati"
              :item-height="45"
              class="vScrollH"
            >
              <template v-slot:default="{ item, index }">
                <v-list-item>
                  <v-list-item-avatar
                    height="33"
                    style="margin-bottom:0; margin-top:0;"
                  >
                    <v-progress-circular
                      :value="progress(item)"
                      :color="progressColor(item)"
                      size="25"
                      ><v-btn
                        icon
                        @click="deleteMenu(item)"
                        title="Cancella il menù"
                        ><v-icon small>mdi-delete-outline</v-icon></v-btn
                      ></v-progress-circular
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <!-- eslint-disable -->
                    <v-list-item-title
                      v-html="trigger && descrizioneMenuNoVariazioni(item)"
                      @click="apriVariazioniDaMenu(index, $event)"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="trigger && descrizioneMenuSoloVariazioni(item)"
                      @click="apriVariazioniDaMenu(index, $event)"
                    ></v-list-item-subtitle>
                    <!-- eslint-enable -->
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
            <!-- </v-list> -->
          </v-card>
        </v-col>
        <v-col v-for="gruppo in gruppi" :key="gruppo.id">
          <v-card v-if="!gruppo.mostraVariazioni">
            <v-card-title style="padding-top: 5px; padding-bottom:5px;"
              >{{ gruppo.name }}<v-spacer></v-spacer
              ><v-icon large :color="coloreGruppo(gruppo)">{{
                iconaColoreGruppo(gruppo)
              }}</v-icon></v-card-title
            >
            <v-card-subtitle style="padding-top: 5px; padding-bottom:5px;">{{
              gruppo.descrizione
            }}</v-card-subtitle>
            <v-list transition="slide-x-transition" dense>
              <v-list-item
                v-for="item in gruppo.children"
                :key="item.id"
                dense
                v-touch="{
                  left: () => swipe(item, gruppo, 'Left'),
                  right: () => swipe(item, gruppo, 'Right'),
                  up: () => swipe(item, gruppo, 'Up'),
                  down: () => swipe(item, gruppo, 'Down'),
                }"
              >
                <v-list-item-avatar
                  height="33"
                  style="margin-bottom:0; margin-top:0;"
                >
                  <v-icon
                    v-if="item.presenzaVariazioni"
                    class="amber lighten-4"
                    :disabled="!item.quantita"
                    @click="apriVariazioni(item, gruppo)"
                    >mdi-clipboard-text-outline</v-icon
                  >
                  <v-icon v-else class="blue-grey lighten-5" disabled
                    >mdi-clipboard-text-off-outline</v-icon
                  >
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <!-- <v-list-item-subtitle>{{ item.descrizione }}</v-list-item-subtitle> -->
                </v-list-item-content>
                <v-list-item-action style="margin:0 !important;">
                  <div class="text-center">
                    <v-btn
                      v-show="trigger && item.quantita"
                      icon
                      @click="decrementa(item, gruppo)"
                      ><v-icon x-large>mdi-minus-box-outline</v-icon></v-btn
                    >
                    <span class="ml-3 mr-3 mt-2 text-h6">{{
                      trigger && item.quantita
                    }}</span>
                    <v-btn icon @click="incrementa(item, gruppo)"
                      ><v-icon x-large>mdi-plus-box-outline</v-icon></v-btn
                    >
                  </div>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
          <v-card v-else color="blue lighten-5">
            <v-card-title
              style="padding-top: 5px; padding-bottom:5px; text-overflow: ellipsis;"
              class="text-h6"
              >Variazioni per
              {{ itemVariazioni && itemVariazioni.name }}</v-card-title
            >
            <v-card-subtitle style="padding-top: 5px; padding-bottom:5px;">{{
              itemVariazioni && itemVariazioni.descrizione
            }}</v-card-subtitle>
            <!-- <v-list dense> -->
            <v-virtual-scroll
              :items="elencoVariazioniDisponibili[gruppo.id]"
              :item-height="35"
              class="vScrollVariazioni"
            >
              <template v-slot:default="{ item }">
                <!-- <v-list-item v-for="v of elencoVariazioniDisponibili" :key="v.codice" dense> -->
                <v-list-item dense>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ item.descrizione
                      }}{{
                        mostraPrezzoVariazioni &&
                        deltaPrezzoVariazioni(item).trim()
                          ? "  ( " + deltaPrezzoVariazioni(item) + ")"
                          : ""
                      }}</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-icon>
                    <v-btn-toggle v-model="item.toggle" dense borderless>
                      <v-btn
                        :disabled="!item.toglie"
                        icon
                        @click="variazioneSub(item, gruppo)"
                        ><v-icon v-show="item.toglie" color="blue"
                          >mdi-minus-box-outline</v-icon
                        ></v-btn
                      >
                      <v-btn
                        :disabled="!item.aggiunge"
                        icon
                        @click="variazioneAdd(item, gruppo)"
                        ><v-icon v-show="item.aggiunge" color="green"
                          >mdi-plus-box-outline</v-icon
                        ></v-btn
                      >
                    </v-btn-toggle>
                  </v-list-item-icon>
                </v-list-item>
              </template>
            </v-virtual-scroll>
            <v-list dense>
              <v-divider class="mt-3"></v-divider>
              <v-list-item
                v-for="p of elencoPreparazioniDisponibili[gruppo.id]"
                :key="p.codice"
                dense
              >
                <v-list-item-content>
                  <v-list-item-title
                    >{{ p.descrizione
                    }}{{
                      mostraPrezzoVariazioni &&
                      deltaPrezzoPreparazioni(p).trim()
                        ? "  ( " + deltaPrezzoPreparazioni(p) + ")"
                        : ""
                    }}</v-list-item-title
                  >
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn-toggle v-model="p.toggle" dense borderless>
                    <v-btn icon @click="preparazioniChange(p, gruppo)"
                      ><v-icon>mdi-plus-box-outline</v-icon></v-btn
                    >
                  </v-btn-toggle>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
            <!-- </v-list> -->
            <v-card-actions>
              <v-btn
                outlined
                text
                @click="chiudiVariazioni(itemVariazioni, gruppo)"
                >ok</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense v-if="posizioneMenuScelti === 'sotto'" class="mt-5">
        <v-col>
          <v-card color="light-green lighten-5">
            <v-card-title style="padding-top: 5px; padding-bottom:5px;"
              >Menù scelti</v-card-title
            >
            <v-virtual-scroll
              :items="menuCreati"
              :item-height="35"
              class="vScrollH2"
            >
              <template v-slot:default="{ item, index }">
                <v-list-item>
                  <v-list-item-avatar
                    height="33"
                    style="margin-bottom:0; margin-top:0;"
                  >
                    <v-progress-circular
                      :value="progress(item)"
                      :color="progressColor(item)"
                      size="25"
                      ><v-btn
                        icon
                        @click="deleteMenu(item)"
                        title="Cancella il menù"
                        ><v-icon small>mdi-delete-outline</v-icon></v-btn
                      ></v-progress-circular
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <!-- eslint-disable -->
                    <v-list-item-title
                      v-html="trigger && descrizioneMenuNoVariazioni(item)"
                      @click="apriVariazioniDaMenu(index, $event)"
                    ></v-list-item-title>
                    <v-list-item-subtitle
                      v-html="trigger && descrizioneMenuSoloVariazioni(item)"
                      @click="apriVariazioniDaMenu(index, $event)"
                    ></v-list-item-subtitle>
                    <!-- eslint-enable -->
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-col>
      </v-row>
      <!--       <v-row no-gutters v-if="!menuSceltiAffiancato">
        <v-col >
          <v-simple-table dense v-if="menuCreati.length > 0">
            <template v-slot:default>
              <thead>
                <tr>
                  <th></th>
                  <th class="text-h6">Menù scelti</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in menuCreati" :key="index" dense>
                  <td width="4%"><v-progress-circular :value="progress(item)" :color="progressColor(item)" size="25"><v-btn icon @click="deleteMenu(item)" title="Cancella il menù"><v-icon small>mdi-delete-outline</v-icon></v-btn></v-progress-circular></td>
                  <td class="text-body-2 text-sm-h7" width="95%" v-html="trigger && descrizioneMenu(item)" @click="apriVariazioniDaMenu(index, $event)"></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row> -->
    </v-container>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      :hide-overlay="true"
      v-if="posizioneMenuScelti === 'drawer'"
      :width="drawerWidth"
      right
      color="light-green lighten-5"
    >
      <template v-slot:prepend> </template>
      <v-col>
        <v-card width="100%" color="light-green lighten-7">
          <v-card-title style="padding-top: 5px; padding-bottom:5px;"
            >Menù selezionati</v-card-title
          >
          <!-- <v-list transition="slide-x-transition" dense> -->
          <v-virtual-scroll
            :items="menuCreati"
            :item-height="45"
            class="vScrollH"
          >
            <template v-slot:default="{ item, index }">
              <v-list-item>
                <v-list-item-avatar
                  height="33"
                  style="margin-bottom:0; margin-top:0;"
                >
                  <v-progress-circular
                    :value="progress(item)"
                    :color="progressColor(item)"
                    size="25"
                    ><v-btn
                      icon
                      @click="deleteMenu(item)"
                      title="Cancella il menù"
                      ><v-icon small>mdi-delete-outline</v-icon></v-btn
                    ></v-progress-circular
                  >
                </v-list-item-avatar>
                <v-list-item-content>
                  <!-- eslint-disable -->
                  <v-list-item-title
                    v-html="trigger && descrizioneMenuNoVariazioni(item)"
                    @click="apriVariazioniDaMenu(index, $event)"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-html="trigger && descrizioneMenuSoloVariazioni(item)"
                    @click="apriVariazioniDaMenu(index, $event)"
                  ></v-list-item-subtitle>
                  <!-- eslint-enable -->
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-virtual-scroll>
          <v-card-actions>
            <v-btn outlined text @click="drawer = !drawer"
              >Chiudi carrello</v-btn
            >
          </v-card-actions>
          <!-- </v-list> -->
        </v-card>
      </v-col>
    </v-navigation-drawer>
  </div>
</template>

<script>
import _ from "lodash";
import { verificaLicenza } from "@/mixins/verificaLicenza.js";
import prodotti from "@/services/prodottiService.js";
import documenti from "@/services/documentiService.js";
import configurazioni from "@/services/configurazioniService.js";

export default {
  props: {
    idmenu: { type: String, default: "" },
    chiave: { type: String, default: "not-set" }
    // menuScontrino: Object
  },
  mixins: [verificaLicenza],
  data: () => ({
    tipoColoreGruppo: "eccesso",
    menu: null,
    trigger: 1,
    menuCreati: [],
    itemVariazioni: null,
    itemMenuSelezionato: null,
    variazioniSelezionate: [],
    preparazioniSelezionate: [],
    elencoVariazioni: [],
    elencoPreparazioni: [],
    elencoVariazioniDisponibili: {},
    elencoPreparazioniDisponibili: {},
    tastiMenu: [],
    tastoMenu: 0,
    idMenu: "",
    menuTotali: null,
    impostazioniMenu: null,
    menuSceltiAffiancato: false,
    menuSceltiDrawer: false,
    drawer: false,
    posizioneMenuScelti: ""
  }),
  async created() {
    setTimeout(async () => {
      const menu = await configurazioni.getConfigurazione("menu");
      this.elencoVariazioni = menu.variazioni;
      this.elencoPreparazioni = menu.preparazioni;
      this.impostazioniMenu = menu.impostazioni;
      // this.menuSceltiAffiancato = menu.impostazioni.menuSceltiAffiancato
      this.posizioneMenuScelti =
        menu.impostazioni.posizioneMenuScelti ||
        (menu.impostazioni.menuSceltiAffiancato ? "affiancato" : "sotto");
    }, 5);
  },
  async mounted() {
    await this.gestioneToken();
    const menuComposti = await prodotti.getMenuComposti();
    this.tastiMenu = menuComposti.docs.map((x) => {
      return {
        codice: x.codice,
        descrizione: x.descrizione
      };
    });
    // this.menuTotali = this.menuScontrino
    if (this.idmenu) {
      this.idMenu = this.idmenu;
      const chiave = `menuTotali_${this.chiave}`;
      const payload = await configurazioni.takeMemoriaCondivisa(chiave);
      if (payload) {
        this.menuTotali = payload.menuTotali || null;
      }
      await this.cambioMenu(this.idmenu);
    }
  },
  watch: {
    async trigger() {
      await this.inviaAggiornamento();
    },
    async idmenu(value) {
      this.idMenu = value;
      await this.cambioMenu(value);
    },
    async menuScontrino(value) {
      this.menuTotali = value;
      // TODO aggiornare ??
    }
  },
  computed: {
    gruppi() {
      return this.menu ? this.menu.composizione.filter((x) => x.attivo) : [];
    },
    totaleMenu() {
      return (this.trigger && this.menu?.totaleMenu) || 0;
    },
    totaleSfusi() {
      return (this.trigger && this.menu?.totaleSfusi) || 0;
    },
    totalePezzi() {
      return this.trigger && (_.sumBy(this.gruppi, "totalePezzi") || 0);
    },
    mostraPrezzoVariazioni() {
      return this.impostazioniMenu?.mostraPrezzoVariazioni || false;
    },
    drawerWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "75vw";
        case "sm":
          return "50vw";
        case "md":
          return "50vw";
        case "lg":
          return "33vw";
        case "xl":
          return "33vw";
        default:
          return "33vw";
      }
    }
  },
  methods: {
    mostraBadge(codice) {
      const valore = this.numeroMenu(codice);
      return !!valore && valore !== "0";
    },
    deltaPrezzoVariazioni(variazione) {
      const piu = (variazione.deltaPrezzoPiu || 0).toFixed(2);
      const meno = (variazione.deltaPrezzoMeno || 0).toFixed(2);
      return `${variazione.deltaPrezzoPiu ? "+" + piu : ""} ${
        variazione.deltaPrezzoPiu && variazione.deltaPrezzoMeno ? "/" : ""
      } ${variazione.deltaPrezzoMeno ? "-" + meno : ""}`;
    },
    deltaPrezzoPreparazioni(preparazione) {
      const delta = (preparazione.deltaPrezzo || 0).toFixed(2);
      return `${preparazione.deltaPrezzo ? "+" + delta : ""}`;
    },
    coloreBadgeMenu(codice) {
      if (!this.menuTotali) return "";
      const mnu = this.menuTotali[codice];
      if (mnu) {
        let totaleSfusi = 0;
        for (let m of mnu.menuCreati) {
          totaleSfusi =
            totaleSfusi + (Object.keys(m).length % mnu.numeroGruppi);
        }
        return totaleSfusi === 0 ? "green" : "red";
      } else {
        return "";
      }
    },
    numeroMenu(codice) {
      if (!this.menuTotali) return 0;
      const mnu = this.menuTotali[codice];
      if (mnu) {
        let totaleSfusi = 0;
        let totaleMenu = 0;
        for (let m of mnu.menuCreati) {
          let ts = Object.keys(m).length % mnu.numeroGruppi;
          if (ts === 0) {
            totaleMenu = totaleMenu + 1;
          } else {
            totaleSfusi = totaleSfusi + ts;
          }
        }
        return `${totaleMenu}${totaleSfusi ? "+" + totaleSfusi : ""}`;
      } else {
        return 0;
      }
    },
    async cambioMenu(codice) {
      const prodotto = await prodotti.getProdotto(codice);
      this.menu = prodotto.menu;

      this.fixQuantita();
      this.tastoMenu = this.tastiMenu.findIndex((x) => x.codice === codice);
      this.idMenu = codice;
      await this.ricaricaMenuEsistenti(codice);
    },
    async ricaricaMenuEsistenti(codice) {
      if (!this.menuTotali) return;

      const payload = this.menuTotali[codice];
      this.menuCreati = payload ? payload.menuCreati || [] : [];
      const gruppi = payload ? payload.gruppi : this.gruppi;

      for (let gc of this.menu.composizione) {
        let g = gruppi.find((x) => x.id === gc.id);
        for (let c of g.children) {
          let c_gc = gc.children.find((x) => x.codice === c.codice);
          c_gc.quantita = c.quantita;
        }
      }

      await this.$nextTick();
      this.calcolaPezzi();
      this.trigger++;
    },
    async inviaAggiornamento() {
      const payload = {
        idmenu: this.idMenu,
        numeroGruppi: this.gruppi.length,
        menuCreati: this.menuCreati,
        gruppi: this.gruppi
      };
      await configurazioni.setMemoriaCondivisa(this.chiave, payload);

      // TODO: Deve rimanere solo questo ?

      this.menuTotali = this.menuTotali || {};
      this.menuTotali[this.idMenu] = payload;
      const chiave = `menuTotali_${this.chiave}`;
      await configurazioni.setMemoriaCondivisa(chiave, this.menuTotali);
    },
    progress(riga) {
      const items = Object.keys(riga);
      return parseInt((items.length / this.gruppi.length) * 100);
    },
    progressColor(riga) {
      // const items = Object.keys(riga)
      const perc = this.progress(riga);
      if (perc < 34) {
        return "#EF5350";
      } else if (perc === 100) {
        return "green";
      } else {
        return "#FF9800";
      }
    },
    descrizioneMenu(menu) {
      const items = Object.keys(menu).sort();
      let strMenu = "";
      for (let i = 0; i < this.gruppi.length; i++) {
        let gr = `gruppo${i + 1}`;
        if (strMenu.length > 0) {
          strMenu = strMenu + " | ";
        }
        if (menu[gr]) {
          strMenu =
            strMenu + `<span data-gruppo="${gr}">${menu[gr].nome}</span>`;
          // *****   Variazioni   ************
          if (menu[gr].variazioni && menu[gr].variazioni.length > 0) {
            let strVar = "[";
            for (let v of menu[gr].variazioni) {
              if (strVar.length > 1) {
                strVar = strVar + ",";
              }
              strVar = strVar + `${v.segno}${v.descrizione}`;
            }
            strVar = strVar + "]";
            strMenu =
              strMenu +
              " " +
              `<span class="text-caption" data-gruppo="${gr}">` +
              strVar +
              "</span>";
          }
          // *****   Preparazioni   ************
          if (menu[gr].preparazioni && menu[gr].preparazioni.length > 0) {
            let strVar = "(";
            for (let v of menu[gr].preparazioni) {
              if (strVar.length > 1) {
                strVar = strVar + ",";
              }
              strVar = strVar + `${v.segno}${v.descrizione}`;
            }
            strVar = strVar + ")";
            strMenu =
              strMenu +
              " " +
              `<span class="text-caption" data-gruppo="${gr}">` +
              strVar +
              "</span>";
          }
        } else {
          strMenu =
            strMenu +
            '<span style="background-color: #EF5350; color: white;">&nbsp?&nbsp</span>';
        }
      }
      return strMenu;
    },
    descrizioneMenuNoVariazioni(menu) {
      const items = Object.keys(menu).sort();
      let strMenu = "";
      for (let i = 0; i < this.gruppi.length; i++) {
        let gr = `gruppo${i + 1}`;
        if (strMenu.length > 0) {
          strMenu = strMenu + " | ";
        }
        if (menu[gr]) {
          strMenu =
            strMenu + `<span data-gruppo="${gr}">${menu[gr].nome}</span>`;
        } else {
          strMenu =
            strMenu +
            '<span style="background-color: #EF5350; color: white;">&nbsp?&nbsp</span>';
        }
      }
      return strMenu;
    },
    descrizioneMenuSoloVariazioni(menu) {
      const items = Object.keys(menu).sort();
      let strMenu = "";
      for (let i = 0; i < this.gruppi.length; i++) {
        let gr = `gruppo${i + 1}`;
        if (strMenu.length > 0) {
          strMenu = strMenu + " | ";
        }
        if (menu[gr]) {
          // *****   Variazioni   ************
          if (menu[gr].variazioni && menu[gr].variazioni.length > 0) {
            let strVar = "";
            for (let v of menu[gr].variazioni) {
              if (strVar.length > 1) {
                strVar = strVar + ",";
              }
              strVar = strVar + `${v.segno}${v.descrizione}`;
            }
            strVar = strVar + "";
            strMenu =
              strMenu +
              " " +
              `<span class="text-caption" data-gruppo="${gr}">` +
              strVar +
              "</span>";
          }
          // *****   Preparazioni   ************
          if (menu[gr].preparazioni && menu[gr].preparazioni.length > 0) {
            let strVar = "";
            for (let v of menu[gr].preparazioni) {
              if (strVar.length > 1) {
                strVar = strVar + ",";
              }
              strVar = strVar + `${v.segno}${v.descrizione}`;
            }
            strVar = strVar + "";
            strMenu =
              strMenu +
              " " +
              `<span class="text-caption" data-gruppo="${gr}">` +
              strVar +
              "</span>";
          }
        }
      }
      return strMenu;
    },
    deleteMenu(riga) {
      const items = Object.keys(riga).sort();
      for (let gr of items) {
        let menu = this.menuCreati.find(
          (x) => x[gr].codice === riga[gr].codice
        );
        const idGruppo = parseInt(gr.substring("gruppo".length));
        let item = this.gruppi[idGruppo - 1].children.find(
          (x) => x.codice === menu[gr].codice
        );
        item.quantita = item.quantita - 1;
      }
      const idx = this.menuCreati.indexOf(riga);
      this.menuCreati.splice(idx, 1);
      this.calcolaPezzi();
      this.trigger++;
    },
    coloreGruppo(gruppo) {
      // TODO: Gestire menu dove è possibile non selezionare un componente (se deltaPrezzo < 0 nel gruppo)
      const p = gruppo.totalePezzi || 0;
      const t = this.menu.totaleMenu || 0;
      const s = this.menu.totaleSfusi || 0;
      const nm = this.menuCreati.length || 0;
      if (t === 0 && s === 0) return "transparent";
      if (this.tipoColoreGruppo === "eccesso") {
        if (p === nm) return "green";
      } else {
        if (p > 0 && p === t) return "green";
      }

      return "red";
    },
    iconaColoreGruppo(gruppo) {
      const p = gruppo.totalePezzi || 0;
      const t = this.menu.totaleMenu || 0;
      const s = this.menu.totaleSfusi || 0;
      const nm = this.menuCreati.length || 0;
      if (t === 0 && s === 0) return "mdi-circle";
      if (this.tipoColoreGruppo === "eccesso") {
        if (p === nm) return "mdi-circle";
      } else {
        if (p > 0 && p === t) return "mdi-circle";
      }

      return `mdi-numeric-${nm - p}-circle`;
    },
    async apriVariazioniDaMenu(index, evento) {
      const codiceGruppo = evento.target.dataset.gruppo;
      if (!codiceGruppo) {
        return;
      }
      this.itemMenuSelezionato = this.menuCreati[index];
      const gruppo = this.gruppi.find((x) => x.id === codiceGruppo);
      const codiceSelezionato = this.itemMenuSelezionato[codiceGruppo].codice;

      this.variazioniSelezionate =
        this.itemMenuSelezionato[codiceGruppo].variazioni || [];
      this.preparazioniSelezionate =
        this.itemMenuSelezionato[codiceGruppo].preparazioni || [];
      const prodottoSelezionato = gruppo.children.find(
        (x) => x.codice === codiceSelezionato
      );
      if (prodottoSelezionato.presenzaVariazioni) {
        await this.apriVariazioni(prodottoSelezionato, gruppo);
      }
    },
    async apriVariazioni(item, gruppo) {
      this.itemVariazioni = item;
      // Caricare le variazioni per il prodotto
      const prodotto = await prodotti.getProdotto(item.codice);
      if (!prodotto) {
        alert("Attenzione! Prodotto non trovato in archivio...");
        return;
      }
      const categorie = prodotto.statistici;
      let elenco = categorie
        ? Object.values(categorie).map((x) => x.codice)
        : [];
      elenco.push(prodotto.datiFiscali.reparto.codice);

      // elenco categorie da visualizzare
      // TODO: Gestire impostazione: Se prodotto ha variazioni --> unisce o sostituisce a quelle delle categorie...

      let variazioniDisponibili = [];
      let preparazioniDisponibili = [];
      variazioniDisponibili = variazioniDisponibili.concat(
        prodotto.variazioni || []
      );
      preparazioniDisponibili = preparazioniDisponibili.concat(
        prodotto.preparazioni || []
      );

      let variazioniPerCategoria = this.elencoVariazioni.filter(
        (x) => _.intersection(elenco, x.elencoCategorie).length > 0
      );
      let vv = variazioniPerCategoria.map((x) => x.variazioni);
      vv = _.flatten(vv);
      variazioniDisponibili = _.unionBy(variazioniDisponibili, vv, "codice");

      let preparazioniPerCategoria = this.elencoPreparazioni.filter(
        (x) => _.intersection(elenco, x.elencoCategorie).length > 0
      );
      let pp = preparazioniPerCategoria.map((x) => x.preparazioni);
      pp = _.flatten(pp);
      preparazioniDisponibili = _.unionBy(
        preparazioniDisponibili,
        pp,
        "codice"
      );

      // (verificare) Deve marcare come selezionati i prodotti da distinta base --> posso solo toglierli o sostituirli
      const prodottiDistinta = await documenti.getProdottiDistinta(prodotto);
      // Se una variazione ha la possibilità di essere tolta, verifica la DB per vedere se presente. Non posso togliere un ingrediente non presente
      // Stessa cosa in aggiunta. Non posso aggiungere un ingrediente già presente

      for (let v of variazioniDisponibili) {
        const pdb = prodottiDistinta.find((x) => x.codice === v.codice);
        if (v.toglie) {
          if (!pdb) {
            // Se non è presente non si può togliere
            v.toglie = false;
          }
        }
        if (v.aggiunge) {
          if (pdb) {
            // Se è già presente non si può aggiungere (per "doppio" fare ingrediente a parte che sostituisce singolo, es. doppia mozzarella, altrimenti sembra un errore)
            v.aggiunge = false;
          }
        }
        const itm = this.variazioniSelezionate.find(
          (x) => x.codice === v.codice
        );
        if (itm) {
          v.toggle = itm.segno === "+" ? 1 : 0;
        } else {
          v.toggle = null; // Due scelte, nessuna selezionata
        }
      }
      for (let v of preparazioniDisponibili) {
        const itm = this.preparazioniSelezionate.find(
          (x) => x.codice === v.codice
        );
        v.toggle = !!itm; // false: Una scelta, non selezionata
      }

      // ---------------------------------------------------
      this.elencoVariazioniDisponibili[
        gruppo.id
      ] = variazioniDisponibili.filter((x) => x.aggiunge || x.toglie); // Viene nascosto se non può essere gestito
      this.elencoVariazioniDisponibili[gruppo.id] = _.sortBy(
        this.elencoVariazioniDisponibili[gruppo.id],
        ["descrizione"]
      );
      // console.log(variazioniDisponibili)
      this.elencoPreparazioniDisponibili[gruppo.id] = preparazioniDisponibili;
      this.elencoPreparazioniDisponibili[gruppo.id] = _.sortBy(
        this.elencoPreparazioniDisponibili[gruppo.id],
        ["descrizione"]
      );
      gruppo.mostraVariazioni = true;

      this.trigger++;
    },
    chiudiVariazioni(item, gruppo) {
      gruppo.mostraVariazioni = false;
      this.itemVariazioni = null;
      this.itemMenuSelezionato = null;
      this.variazioniSelezionate = [];
      this.preparazioniSelezionate = [];
      this.trigger++;
    },
    swipe(item, gruppo, direction) {
      console.log("swipe", direction);
      switch (direction) {
        case "Left":
          // this.decrementa(item, gruppo)
          break;
        case "Right":
          // this.incrementa(item, gruppo)
          this.apriVariazioni(item, gruppo);
          break;
        default:
          break;
      }
    },
    calcolaPezzi() {
      for (let g of this.gruppi) {
        g.totalePezzi = _.sumBy(g.children, "quantita");
      }
      this.menu.totaleMenu = _.minBy(this.gruppi, "totalePezzi").totalePezzi;
      const totPezzi = _.sumBy(this.gruppi, "totalePezzi");
      const totPezziInMenu = (this.menu.totaleMenu || 0) * this.gruppi.length;
      this.menu.totaleSfusi = totPezzi - totPezziInMenu;
    },
    fixQuantita() {
      for (let g of this.gruppi) {
        for (let p of g.children) {
          if (p.quantita === undefined) {
            p.quantita = 0;
          }
        }
      }
    },
    decrementa(item, gruppo) {
      if (item.quantita > 0) {
        item.quantita = item.quantita - 1;
        this.calcolaPezzi();
        this.trigger++;
        for (let i = this.menuCreati.length - 1; i >= 0; i--) {
          if (
            this.menuCreati[i][gruppo.id] &&
            this.menuCreati[i][gruppo.id].codice === item.codice
          ) {
            let menuCorrente = this.menuCreati[i];
            delete menuCorrente[gruppo.id];
            break;
          }
        }
        this.verificaMenuVuoti();
      }
    },
    verificaMenuVuoti() {
      const keys = Object.keys(this.menuCreati);
      for (let k of keys) {
        const riga = this.menuCreati[k];
        if (Object.keys(riga).length === 0) {
          this.deleteMenu(riga);
        }
      }
    },
    incrementa(item, gruppo) {
      if (this.menuCreati.length <= (gruppo.totalePezzi || 0)) {
        this.menuCreati.push({});
      }
      for (let i = 0; i < this.menuCreati.length; i++) {
        if (!this.menuCreati[i][gruppo.id]) {
          let menuCorrente = this.menuCreati[i];
          menuCorrente[gruppo.id] = {
            gruppo: gruppo.name,
            codice: item.codice,
            nome: item.name,
            id: item.id
            // eventuali varianti
          };
          break;
        }
      }
      item.quantita = item.quantita + 1;
      this.calcolaPezzi();
      this.trigger++;
    },
    async variazioneAdd(v, gruppo) {
      await this.$nextTick();
      let item = this.itemVariazioni;
      const daAggiungere = {
        segno: "+",
        codice: v.codice,
        descrizione: v.descrizione,
        deltaPrezzo: v.deltaPrezzoPiu,
        deltaQuantita: v.quantitaPiu || 0,
        stampa: item.stampa || gruppo.stampa // TODO: Verificare
      };

      let im = this.menuCreati.filter(
        (x) => x[gruppo.id] && x[gruppo.id].id === item.id
      );
      // Prende l'ultimo inserito oppure quello selezionato se aperto da menu scelti
      let itemMenuCreati = this.itemMenuSelezionato
        ? this.itemMenuSelezionato
        : im[im.length - 1];
      itemMenuCreati[gruppo.id].variazioni =
        itemMenuCreati[gruppo.id].variazioni || [];
      itemMenuCreati[gruppo.id].variazioni = itemMenuCreati[
        gruppo.id
      ].variazioni.filter((x) => x.codice !== v.codice);
      if (v.toggle === 1) {
        itemMenuCreati[gruppo.id].variazioni.push(daAggiungere);
      }
      this.trigger++;
    },
    async variazioneSub(v, gruppo) {
      await this.$nextTick();
      let item = this.itemVariazioni;
      const daAggiungere = {
        segno: "-",
        codice: v.codice,
        descrizione: v.descrizione,
        deltaPrezzo: v.deltaPrezzoMeno,
        deltaQuantita: v.quantitaMeno || 0,
        stampa: item.stampa || gruppo.stampa // TODO: Verificare
      };

      let im = this.menuCreati.filter(
        (x) => x[gruppo.id] && x[gruppo.id].id === item.id
      );
      let itemMenuCreati = this.itemMenuSelezionato
        ? this.itemMenuSelezionato
        : im[im.length - 1];
      itemMenuCreati[gruppo.id].variazioni =
        itemMenuCreati[gruppo.id].variazioni || [];
      itemMenuCreati[gruppo.id].variazioni = itemMenuCreati[
        gruppo.id
      ].variazioni.filter((x) => x.codice !== v.codice);
      if (v.toggle === 0) {
        itemMenuCreati[gruppo.id].variazioni.push(daAggiungere);
      }
      this.trigger++;
    },
    async preparazioniChange(p, gruppo) {
      await this.$nextTick();
      let item = this.itemVariazioni;
      const daAggiungere = {
        segno: "+",
        codice: p.codice,
        descrizione: p.descrizione,
        deltaPrezzo: p.deltaPrezzo,
        stampa: item.stampa || gruppo.stampa // TODO: Verificare
      };

      let im = this.menuCreati.filter((x) => x[gruppo.id].id === item.id);
      // Prende l'ultimo inserito oppure quello selezionato se aperto da menu scelti
      let itemMenuCreati = this.itemMenuSelezionato
        ? this.itemMenuSelezionato
        : im[im.length - 1];
      itemMenuCreati[gruppo.id].preparazioni =
        itemMenuCreati[gruppo.id].preparazioni || [];
      itemMenuCreati[gruppo.id].preparazioni = itemMenuCreati[
        gruppo.id
      ].preparazioni.filter((x) => x.codice !== p.codice);
      if (p.toggle === 0) {
        itemMenuCreati[gruppo.id].preparazioni.push(daAggiungere);
      }
      this.trigger++;
    }
  }
};
</script>

<style scoped>
/* TODO: Da sistemare, dovrebbero essere dinamici ma attualmente il componente virtual scoller non prende dinamicamente l'altezza */
.vScrollH {
  height: 81vh;
  background-color: white;
}

.vScrollH2 {
  height: 40vh;
  background-color: white;
}

.vScrollVariazioni {
  height: 50vh;
  background-color: white;
}
</style>
